import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';
import { PdfShortcutHeader } from 'components/Pdf/PrintPdfShortcut';
import FluidsSection from 'pages/CatalogPage/DH/Maintenance/Fluids/FluidsSection';
import { MaintenanceViewProps } from 'pages/CatalogPage/DH/Maintenance/Maintenance';
import { printCss } from 'pages/CatalogPage/DH/Maintenance/Maintenance.styled';
import MileageTimeSection from 'pages/CatalogPage/DH/Maintenance/Mileage/MileageTimeSection';
import ServiceSection from 'pages/CatalogPage/DH/Maintenance/Services/ServiceSection';
import SpecialInformation from 'pages/CatalogPage/DH/Maintenance/Services/SpecialInformation';
import { PrintButtonRound } from 'UI';
import { PdfHiddenWrapper, PdfWrapper, usePrintShortcut } from 'utils/hooks/usePrintShortcut';

const MaintenancePdf = ({ maintenancePlanData, getLabel, units, val }: MaintenanceViewProps) => {
  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({
    contentRef,
    pageStyle: printCss.toString(),
  });

  usePrintShortcut(reactToPrintFn);

  return (
    <>
      <PrintButtonRound onClick={reactToPrintFn} />
      <PdfHiddenWrapper>
        <PdfWrapper direction={'column'} ref={contentRef} gap={20}>
          <PdfShortcutHeader title={t('catalog.parts.category.maintenance_plan', 'Maintenance plan')} />
          <MileageTimeSection
            maintenancePlanData={maintenancePlanData}
            getLabel={getLabel}
            units={units}
            val={val}
            printView
          />
          <ServiceSection maintenancePlanData={maintenancePlanData} getLabel={getLabel} printView />
          <SpecialInformation specialInformation={maintenancePlanData.specialInformationList} printView />
          <FluidsSection maintenancePlanData={maintenancePlanData} getLabel={getLabel} />
        </PdfWrapper>
      </PdfHiddenWrapper>
    </>
  );
};

export default MaintenancePdf;
